import { render, staticRenderFns } from "./ReportB01.vue?vue&type=template&id=45a07cea&scoped=true"
import script from "./ReportB01.vue?vue&type=script&lang=js"
export * from "./ReportB01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a07cea",
  null
  
)

export default component.exports